import Snackbar, { customMsg, errorMsg, successMsg } from './Snackbar';

export { customMsg, errorMsg, successMsg };
export default Snackbar;
